// -------- GENERAL --------
export const RESET_GENERAL_STATE = 'resetGeneralState';
export const PREVIEW_STATE = 'setPreviewState';
export const SET_TRACKING_CODE = 'setTrackingCode';
export const SET_TRACKING_PHONE = 'setTrackingPhone';
